// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uVDTU","menuList":"Menu_menuList__qzxTC","menuItem":"Menu_menuItem__mA82b","menuItemActive":"Menu_menuItemActive__i7BKW"};